define('SC.SummitThemeExtension.Shopping', [
  'SC.SummitThemeExtension.ErrorManagement',
  'SC.SummitThemeExtension.Footer',
  'SC.SummitThemeExtension.Home',
  'SC.SummitThemeExtension.HomeCMS',
  'SC.SummitThemeExtension.ApplicationSkeleton.Layout',
  'SC.SummitThemeExtension.ItemRelations.SC.Configuration',
  'SC.SummitThemeExtension.LoadWebFont',
  'SC.SummitThemeExtension.Common.Configuration',
  'SC.SummitThemeExtension.Common.LayoutHelper',
  'Utils',
  'underscore'
], function SCSummitThemeExtensionShoppingEntryPoint(
  SummitThemeExtErrorManagement,
  SummitThemeExtFooter,
  SummitThemeExtHome,
  SummitThemeExtHomeCMS,
  SummitThemeExtApplicationSkeleton,
  SummitThemeExtItemRelations,
  SummitThemeExtLoadWebFont,
  Configuration,
  LayoutHelper,
  Utils,
  _
) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      Configuration.setEnvironment(container.getComponent('Environment'));
      LayoutHelper.setLayoutComponent(container.getComponent('Layout'));
      SummitThemeExtApplicationSkeleton.toggleViewportToMobileSupport();
      Utils.initBxSlider = _.initBxSlider = _.wrap(
        _.initBxSlider,
        function initBxSlider(fn) {
          var autoPlayCarousel = Configuration.get('home.autoPlayCarousel');
          var carouselSpeed = Configuration.get('home.carouselSpeed');

          if (
            arguments.length !== 0 &&
            arguments[1] &&
            arguments[1][0] &&
            arguments[1][0].id === 'home-image-slider-list'
          ) {
            arguments[2] = _.extend(arguments[2], {
              auto: autoPlayCarousel,
              pause: carouselSpeed
            });
          }

          return fn.apply(this, _.toArray(arguments).slice(1));
        }
      );
      SummitThemeExtErrorManagement.loadModule();
      SummitThemeExtFooter.loadModule();
      SummitThemeExtHome.loadModule();
      SummitThemeExtHomeCMS.mountToApp(container);
      SummitThemeExtApplicationSkeleton.loadModule();
      SummitThemeExtItemRelations.loadModule();
      SummitThemeExtLoadWebFont.loadModule();
    }
  };
});
